/* Cozyloom theme JS. No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat(root.lang || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function sizedImg(url, w) {
    if (!url) return '';
    var q = url.indexOf('?'), base = q > -1 ? url.slice(0, q) : url, qs = q > -1 ? url.slice(q) : '', d = base.lastIndexOf('.');
    return d < 0 ? url : base.slice(0, d) + '_' + w + 'x' + base.slice(d) + qs;
  }

  var overlay = $('[data-cl-overlay]');
  var openEl = null, lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    closeDrawers(true);
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.removeAttribute('aria-hidden');
    if (overlay) overlay.classList.add('is-open');
    root.style.overflow = 'hidden'; openEl = el;
    var f = $('button, a[href], input', el); if (f) f.focus();
  }
  function closeDrawers(keepFocus) {
    $$('.cl-cart.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('is-open');
    root.style.overflow = ''; openEl = null;
    if (!keepFocus && lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cl-open],[data-cl-close]');
    if (!t) { if (e.target === overlay) closeDrawers(); return; }
    if (t.hasAttribute('data-cl-open')) { e.preventDefault(); if (t.getAttribute('data-cl-open') === 'cart') renderCart(); openDrawer($('[data-cl-drawer="cart"]')); }
    else closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openEl) closeDrawers(); });

  var cartEl = $('[data-cl-drawer="cart"]');
  function setCount(n) { $$('[data-cl-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; }); }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function renderCart(cart) {
    if (!cartEl) return;
    (cart ? Promise.resolve(cart) : getCart()).then(function (c) {
      setCount(c.item_count);
      var list = $('[data-cl-lines]', cartEl), foot = $('[data-cl-foot]', cartEl), ship = $('[data-cl-ship]', cartEl);
      list.innerHTML = '';
      if (!c.items.length) {
        list.innerHTML = '<li class="cl-empty"><p>' + esc(cartEl.dataset.empty || 'Your cart is empty.') + '</p><a class="cl-btn" href="' + esc(cartEl.dataset.shop || '/collections/all') + '">' + esc(cartEl.dataset.continue || 'Continue shopping') + '</a></li>';
        foot.hidden = true; if (ship) ship.hidden = true; return;
      }
      foot.hidden = false;
      c.items.forEach(function (it, i) {
        var li = document.createElement('li'); li.className = 'cl-line';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        li.innerHTML =
          (it.image ? '<img src="' + esc(sizedImg(it.image, 144)) + '" alt="' + esc(it.product_title) + '" width="72" height="72" loading="lazy">' : '<span></span>') +
          '<div><a class="cl-line__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (variant ? '<div class="cl-line__v">' + esc(variant) + '</div>' : '') +
          '<div class="cl-line__row"><div class="cl-qty"><button type="button" aria-label="Decrease quantity" data-q="' + (it.quantity - 1) + '" data-i="' + (i + 1) + '">&minus;</button>' +
          '<input type="text" inputmode="numeric" readonly value="' + it.quantity + '" aria-label="Quantity"><button type="button" aria-label="Increase quantity" data-q="' + (it.quantity + 1) + '" data-i="' + (i + 1) + '">+</button></div>' +
          '<strong>' + money(it.final_line_price) + '</strong></div>' +
          '<button type="button" class="cl-link" data-q="0" data-i="' + (i + 1) + '">Remove</button></div>';
        list.appendChild(li);
      });
      $('[data-cl-sub]', cartEl).textContent = money(c.total_price);
      var th = parseFloat(cartEl.dataset.threshold || '0') * 100;
      if (ship) {
        if (th > 0) {
          ship.hidden = false;
          var left = th - c.total_price;
          $('[data-cl-ship-text]', ship).textContent = left > 0 ? (cartEl.dataset.away || "You're {amount} away from free shipping").replace('{amount}', money(left)) : (cartEl.dataset.unlocked || 'You have free shipping!');
          $('[data-cl-ship-bar]', ship).style.width = Math.min(100, (c.total_price / th) * 100) + '%';
        } else ship.hidden = true;
      }
    });
  }
  if (cartEl) cartEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b) return;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.i, quantity: +b.dataset.q }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  });

  function addToCart(form, btn) {
    var fd = new FormData(form), label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.adding || 'Adding...'; }
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); })
      .then(function () { return getCart(); })
      .then(function (c) { renderCart(c); openDrawer(cartEl); })
      .catch(function (err) { var m = $('[data-cl-error]', form); if (m) { m.textContent = err.message; m.hidden = false; } else alert(err.message); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-cl-add]'); if (!f) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault(); addToCart(f, $('[data-cl-submit]', f) || $('[type="submit"]', f) || null);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]'); if (!b) return;
    var inp = $('input', b.parentNode);
    inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (+b.dataset.step));
  });

  $$('[data-cl-product]').forEach(function (box) {
    var data = JSON.parse($('script[type="application/json"][data-cl-variants]', box).textContent);
    var form = $('form[data-cl-add]', box), idInput = $('[name="id"]', form);
    var priceEl = $('[data-cl-price]', box), main = $('[data-cl-main]', box), mini = $('[data-cl-price-mini]');
    var btns = $$('[data-cl-submit]', box).concat(box.dataset.clUrl ? $$('[data-cl-sticky] [data-cl-submit]') : []);
    function selected() { return $$('.cl-opt', box).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function update() {
      var sel = selected();
      var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      btns.forEach(function (b) { b.disabled = !v || !v.available; b.textContent = !v ? b.dataset.unavailable : (v.available ? b.dataset.label : b.dataset.soldout); });
      if (!v) return;
      idInput.value = v.id; if (mini) mini.textContent = money(v.price);
      if (priceEl) priceEl.innerHTML = '<span>' + money(v.price) + '</span>' + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      if (v.featured_image && main) { main.src = v.featured_image.src; main.removeAttribute('srcset'); main.alt = v.featured_image.alt || data.title; }
      if (box.dataset.clUrl === 'true') { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    box.addEventListener('change', function (e) { if (e.target.closest('.cl-opt')) update(); });
    $$('.cl-gal__thumbs button', box).forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.src; main.removeAttribute('srcset'); main.alt = t.dataset.alt;
        $$('.cl-gal__thumbs button', box).forEach(function (o) { o.setAttribute('aria-current', o === t); });
      });
    });
    update();
  });

  var sticky = $('[data-cl-sticky]'), anchor = $('[data-cl-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(anchor);
    $('[data-cl-sticky-btn]', sticky).addEventListener('click', function () { var f = $('form[data-cl-add]'); if (f) f.requestSubmit(); });
  }

  var rev = $$('.cl-reveal');
  if (rev.length) {
    if (reduce || !('IntersectionObserver' in window)) rev.forEach(function (r) { r.classList.add('is-in'); });
    else { var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' }); rev.forEach(function (r) { io.observe(r); }); }
  }

  $$('.cl-ugc__item video').forEach(function (v) {
    var btn = $('button', v.parentNode);
    if (btn) btn.addEventListener('click', function () { if (v.paused) { v.play(); btn.setAttribute('aria-label', 'Pause video'); } else { v.pause(); btn.setAttribute('aria-label', 'Play video'); } });
    if (!reduce && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } }, { threshold: .5 }).observe(v);
  });

  if (cartEl) getCart().then(function (c) { setCount(c.item_count); });
})();